module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-common-selector"
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "placeholder": _vm.placeholder || '请选择',
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.showDialog
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.showDialog
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('rt-common-dialog', {
    ref: "commonDialog",
    attrs: {
      "data-source": _vm.dataSource,
      "display-fields": _vm.displayFields,
      "value-field": _vm.valueField,
      "dialog-title": _vm.dialogTitle,
      "search-placeholder": _vm.searchPlaceholder,
      "current-value": _vm.value
    },
    on: {
      "item-selected": _vm.handleItemSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63995112"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/common-selector/src/common-selector.vue
// module id = 1437
// module chunks = 116